import { LoadingOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import IconButton from 'components/@extended/IconButton';
import { useState } from 'react';
import { dispatch } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';

const DeleteButton = ({
    deleteCallback,
    refreshCallback,
    deleteItemName,
}: {
    deleteCallback: () => Promise<number | null>;
    refreshCallback: () => Promise<void>;
    deleteItemName?: string;
}): JSX.Element => {
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const handleDelete = async () => {
        setIsLoading(true);

        deleteCallback()
            .then((res) => {
                if (res === 200)
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: `Delete ${deleteItemName ?? ''} successfully!`,
                            variant: 'alert',
                            alert: {
                                color: 'success',
                            },
                        }),
                    );
                else
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: `Cannot delete ${deleteItemName ?? ''}!`,
                            variant: 'alert',
                            alert: {
                                color: 'error',
                            },
                        }),
                    );
                refreshCallback();
            })
            .finally(() => {
                setIsLoading(false);
                setIsOpen(false);
            });
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    if (isLoading) return <LoadingOutlined style={{ padding: '9px' }} />;

    return (
        <>
            <IconButton onClick={() => setIsOpen(true)} shape="rounded" color="error">
                <DeleteOutlined />
            </IconButton>
            <Dialog open={isOpen} onClose={handleClose} aria-labelledby="responsive-dialog-title">
                <DialogTitle id="responsive-dialog-title">Are you sure want to delete?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Deleting <b>{deleteItemName}</b> is irreversible! Proceed?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} autoFocus color="error" disabled={isLoading}>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DeleteButton;
